/**
 *
 * Greenhouse Featured jobs
 *
 * UI to handle the retrieval of featured jobs the Greenhouse Jobs Component
 */

const $ = require( 'jQuery' );

    var FeaturedGHUI = function(el){

        this.$el        = $(el);
        this.jobsNum    =  parseInt( this.$el.attr( 'data-gh-num' ) );
        this.$loading   = this.$el.find( '.itbl-b-circle__loader' );

        //variables
        this.API        = 'https://boards-api.greenhouse.io/v1/boards/iterable/jobs?content=true';
        this.AjaxCall   = null;
        this.jobsObj    = null;
        this.html       = [];


        this.init();
    };

    FeaturedGHUI.prototype.init = function(){

        this.AjaxCall = this.model__getJobs()
            .success( (response )=> {

                //get the first 3 jobs from response
                this.jobsObj = response.jobs.slice( 0, this.jobsNum );

                this.view__renderJobs();

            } )
            .fail( ( response )=>{

                console.log( 'Greenhouse API Failed: ', response );
                this.$loading.hide();

            } );



    };

    FeaturedGHUI.prototype.model__getJobs = function( ){

        return $.ajax({
            type        : 'GET',
            url         : this.API,
            dataType    : 'JSONP'
        });


    };

    FeaturedGHUI.prototype.view__renderJobs = function( ){

        var icon,
        that = this;


        $.each( this.jobsObj, ( i, v )=>{

            if( v.departments[0].id in ITBL.gh_icons ){

                icon = ITBL.gh_icons[ v.departments[0].id ];

            }else if( 'default' in ITBL.gh_icons  ){
                icon   = ITBL.gh_icons[ 'default'];
            }else{
                //if for some ungodly reason we don't have either of these two icons, then let's select one randomly from what we have
                icon   = ITBL.gh_icons[ Math.floor(Math.random() *  Object.keys( ITBL.gh_icons ).length )   ];
            }

            var url         = v.absolute_url;
            var location    = v.location.name;
            var title       = v.title;

            let htmlWrapper = $('<div />')
                .addClass( 'cell small-12 medium-4 itbl-c-gh__career-wrapper itbl-u-py-nudge itbl-u-px-nudge text-center' );

            let htmlInnerLink = $('<a />')
                .addClass('itbl-u-display-block itbl-c-gh__career_url')
                .attr( {
                    'href'      : url,
                    'target'    : '_blank'
                } )
                .append([
                    $( '<img />' )
                        .addClass( 'itbl-c-gh__career_icon' )
                        .attr({
                            'src'   : icon,
                            'alt'   : title
                        }),
                    $('<p />')
                        .addClass( 'small ibl-u-weight-bold itbl-u-font-color--dark-gray h5 itbl-u-mt-nudge' )
                        .text( title ),
                    $('<p />')
                        .addClass( 'small itbl-u-font-color--dark-gray' )
                        .text( location )

                ]);

            htmlWrapper.append( htmlInnerLink );
            that.html.push( htmlWrapper )

        } );

        this.$loading.hide();
        this.$el.append( this.html );

    };

    $(document).ready(function(){
        $('.js-itbl-c-gh').each(function(){
            new FeaturedGHUI(this);
        });

    });


// Initialize dynamic block preview (editor).
if( window.acf ) {

    window.acf.addAction( 'render_block_preview/type=gh-jobs', function( el, props ){


        $(el).find('.js-itbl-c-gh').each(function(){
            new FeaturedGHUI(this);
        });

    } );
}
